import React from 'react';
import { useCurrentUser } from '../../services/currentUser';
import { useCopilotAccess } from './useCopilotAccess';
import { DadoCopilot } from './index';

export const DadoCopilotGated: React.FC = () => {
  const { org } = useCurrentUser();
  const { canAccess } = useCopilotAccess();
  if (!canAccess) return null;
  return <DadoCopilot organizationId={org.id} />;
};
